import {useCallback, useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import type {ITab} from "@pg-design/tabs-v2-module";
import {Tabs} from "@pg-design/tabs-v2-module";

import {IRPStore} from "../../../app/rp_reducer";
import {hitPromotionTabClick} from "../../../tracking/google_tag_manager/gtm_promotion_events";
import {buildPromotionListUrlFromRegion} from "../../helpers/build_promotion_list_url";
import {getPromotionListingConfig, getPromotionListingType, promotionListingTypes} from "../../helpers/promotion_listing_config";
import {PromotionType} from "../../helpers/PromotionType";

export const PromotionListTabs = () => {
    const promotionType = useSelector((state: IRPStore) => state.promotionList.form.formValues.type);
    const region = useSelector((state: IRPStore) => state.promotionList.region);
    const activeType = getPromotionListingType(promotionType);

    const tabs = useMemo<ITab<PromotionType>[]>(() => {
        return promotionListingTypes.map((type) => {
            const config = getPromotionListingConfig(type);
            const isActive = activeType === type;

            return {
                title: config.shortLabel,
                value: type,
                href: isActive ? undefined : buildPromotionListUrlFromRegion({type, region})
            };
        });
    }, [activeType, region]);

    const handleTabChange = useCallback(
        (type: PromotionType) => {
            if (type === activeType) {
                return;
            }

            hitPromotionTabClick(getPromotionListingConfig(type).shortLabel);
        },
        [activeType]
    );

    return (
        <div className={tabsScrollerStyle}>
            <Tabs
                activeAriaCurrent="page"
                nativeLinkNavigation
                onChange={handleTabChange}
                size="default"
                tabs={tabs}
                titleClassName={tabTitleStyle}
                value={activeType}
                variant="default"
            />
        </div>
    );
};

const tabsScrollerStyle = css({
    mb: 3,
    minWidth: 0,
    overflowX: "auto",
    md: {
        mb: 4
    }
});

const tabTitleStyle = css({
    minWidth: "18.1rem"
});
import {useCallback, useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import type {ITab} from "@pg-design/tabs-v2-module";
import {Tabs} from "@pg-design/tabs-v2-module";

import {IRPStore} from "../../../app/rp_reducer";
import {hitPromotionTabClick} from "../../../tracking/google_tag_manager/gtm_promotion_events";
import {buildPromotionListUrlFromRegion} from "../../helpers/build_promotion_list_url";
import {getPromotionListingConfig, getPromotionListingType, promotionListingTypes} from "../../helpers/promotion_listing_config";
import {PromotionType} from "../../helpers/PromotionType";

export const PromotionListTabs = () => {
    const promotionType = useSelector((state: IRPStore) => state.promotionList.form.formValues.type);
    const region = useSelector((state: IRPStore) => state.promotionList.region);
    const activeType = getPromotionListingType(promotionType);

    const tabs = useMemo<ITab<PromotionType>[]>(() => {
        return promotionListingTypes.map((type) => {
            const config = getPromotionListingConfig(type);
            const isActive = activeType === type;

            return {
                title: config.shortLabel,
                value: type,
                href: isActive ? undefined : buildPromotionListUrlFromRegion({type, region})
            };
        });
    }, [activeType, region]);

    const handleTabChange = useCallback(
        (type: PromotionType) => {
            if (type === activeType) {
                return;
            }

            hitPromotionTabClick(getPromotionListingConfig(type).shortLabel);
        },
        [activeType]
    );

    return (
        <div className={tabsScrollerStyle}>
            <Tabs
                activeAriaCurrent="page"
                nativeLinkNavigation
                onChange={handleTabChange}
                size="default"
                tabs={tabs}
                titleClassName={tabTitleStyle}
                value={activeType}
                variant="default"
            />
        </div>
    );
};

const tabsScrollerStyle = css({
    mb: 3,
    minWidth: 0,
    overflowX: "auto",
    md: {
        mb: 4
    }
});

const tabTitleStyle = css({
    minWidth: "18.1rem"
});
